// Interfaces
import { ISearchParameters, Report } from "../Interfaces/TableInterfaces";
import { Packet } from "src/Interfaces/commonDtos";
import {
  IFundNoRiskTableReport,
  ISandooghDTO,
  IFundNoRiskAddTaskDTO,
  IExeConfigDTO,
  ISandooghDropdownDTO,
  IFundNoRiskSearchParam,
  IMainInstrumentConfigDTO,
  IBuyingPowerCriterionDropdownDTO,
} from "src/Interfaces/fundNoRisk";
// Utilities
import {
  deleteRequest,
  getRequest,
  getTable, postRequest,
  putRequest
} from "./requestTemplates";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { AxiosRequestConfig } from "axios";

/**
 * FundNoRiskTask
 * چدول صندوق درآمد ثابت
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getFundNoRiskTable = (
  searchParam: IFundNoRiskSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig
): Promise<Report<IFundNoRiskTableReport>> =>
  getTable<IFundNoRiskSearchParam, IFundNoRiskTableReport>(
    "/v1/FundNoRisk/Task",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions
  );

export interface NoRiskTradeInputDTO extends ISearchParameters {
  taskId: number;
}

export const getFundNoRiskSellOrderTable = (
  searchParam: NoRiskTradeInputDTO,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IFundNoRiskTableReport>> =>
  getTable<ISearchParameters, IFundNoRiskTableReport>(
    "/v1/FundNoRisk/GetSellorder",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getFundNoRiskBuyOrderTable = (
  searchParam: NoRiskTradeInputDTO,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IFundNoRiskTableReport>> =>
  getTable<ISearchParameters, IFundNoRiskTableReport>(
    "/v1/FundNoRisk/GetBuyorder",
    searchParam,
    offset,
    pageSize,
    sortingType
  );

/**
 * FundNoRiskTask
 * لیست صندوق‌های درآمد ثابت
 *
 * @async
 * @version 1.4.0
 */
export const getSandooghsDropDown = (): Promise<ISandooghDropdownDTO[]> =>
  getRequest("/v1/FundNoRisk/GetAllSandoghDropdown");

export const getBuyingPowerCriteria = (): Promise<
  IBuyingPowerCriterionDropdownDTO[]
> => getRequest("/v1/FundNoRisk/Task/BuyingPowerCriteria");

/**
 * FundNoRiskTask
 * دکمه ثبت صندوق‌های درآمد ثابت
 *
 * @param {string[]} ids
 * @async
 * @version 1.4.0
 */

/**
 * FundNoRiskTask
 * دکمه صندوق‌های درآمد ثابت
 *
 * @async
 * @version 1.4.0
 */
export const getSandooghs = (): Promise<ISandooghDTO> =>
  getRequest("/v1/FundNoRisk/GetAllSandogh");

export const setAllSandoogh = (ids: string[]): Promise<Packet<boolean>> =>
  postRequest("/v1/FundNoRisk/SetAllSandogh", { ids });

/**
 * FundNoRiskTask
 * دریافت لیست نمادهای صندوق شبه درآمد ثابت
 *
 * @async
 */
export const getMainInstrumentConfig =
  (): Promise<IMainInstrumentConfigDTO> =>
    getRequest("/v1/FundNoRisk/Task/GetMainInstrumentConfig");

/**
 * FundNoRiskTask
 * ذخیره لیست نمادهای صندوق شبه درآمد ثابت
 *
 * @param {string[]} instrumentIds
 * @async
 */
export const setMainInstrumentConfig = (
  instrumentIds: string[],
): Promise<Packet<boolean>> =>
  putRequest("/v1/FundNoRisk/Task/SetMainInstrumentConfig", { instrumentIds });

/**
 * FundNoRiskTask
 * دکمه ثبت افزودن صندوق درآمد ثابت
 *
 * @param {IFundNoRiskAddTaskDTO} data
 * @async
 * @version 1.4.0
 */
export const addFundNoRisk = (
  data: IFundNoRiskAddTaskDTO
): Promise<Packet<boolean>> => postRequest("/v1/FundNoRisk/Task/AddTask", data);

/**
 * FundNoRiskTask
 * دکمه ویرایش در جدول
 *
 * @param {IFundNoRiskAddTaskDTO} data
 * @async
 * @version 1.4.0
 */
export const editFundNoRisk = (
  data: IFundNoRiskAddTaskDTO
): Promise<Packet<boolean>> =>
  postRequest("/v1/FundNoRisk/Task/EditTask", data);

/**
 * FundNoRiskTask
 * دکمه حذف از جدول
 *
 * @param {id} number
 * @async
 * @version 1.4.0
 */
export const deleteFundNoRisk = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/FundNoRisk/Task/Delete?id=${id}`);

/**
 * FundNoRiskTask
 * دکمه ثبت تنظیمات
 *
 * @param {IExeConfigDTO} data
 * @async
 * @version 1.4.0
 */
export const setExeConfig = (data: IExeConfigDTO): Promise<Packet<boolean>> =>
  putRequest("/v1/FundNoRisk/Task/setExeConfig", data);

export const getExeConfig = (): Promise<IExeConfigDTO> =>
  getRequest("/v1/FundNoRisk/Task/getExeConfig");

/**
 * FundNoRiskTask
 * ارسال خرید
 *
 * @param {taskId} number
 * @async
 * @version 1.4.0
 */
export const manualSell = (taskId: number): Promise<Packet<boolean>> =>
  postRequest(`/v1/FundNoRisk/Task/manualSell`, { taskId });

/**
 * FundNoRiskTask
 * ارسال فروش
 *
 * @param {taskId} number
 * @async
 * @version 1.4.0
 */
export const manualBuy = (taskId: number): Promise<Packet<boolean>> =>
  postRequest(`/v1/FundNoRisk/Task/manualbuy`, { taskId });

/**
 * FundNoRiskTask
 * حذف صندوق‌های درآمد ثابت انتخاب شده
 *
 * @async
 * @version 1.4.0
 */
export const bulkCancel = (ids: number[]): Promise<Packet<boolean>> =>
  postRequest("/v1/FundNoRisk/Task/DeleteBulk", { ids });

/**
 * FundNoRiskTask
 * عملیات گروهی -> خاموش کردن فروش
 *
 * @param {ids} number[]
 * @async
 * @version 1.4.0
 */
export const sellBulkDisable = (ids: number[]): Promise<Packet<boolean>> =>
  putRequest("/v1/FundNoRisk/turnOffSellBulk", ids);

/**
 * FundNoRiskTask
 * عملیات گروهی -> روشن کردن فروش
 *
 * @param {ids} number[]
 * @async
 * @version 1.4.0
 */
export const sellBulkEnable = (ids: number[]): Promise<Packet<boolean>> =>
  putRequest("/v1/FundNoRisk/turnOnSellBulk", ids);

/**
 * FundNoRiskTask
 * عملیات گروهی -> خاموش کردن فروش
 *
 * @param {ids} number[]
 * @async
 * @version 1.4.0
 */
export const buyBulkDisable = (ids: number[]): Promise<Packet<boolean>> =>
  putRequest("/v1/FundNoRisk/turnOffBuyBulk", ids);

/**
 * FundNoRiskTask
 * عملیات گروهی -> روشن کردن فروش
 *
 * @param {ids} number[]
 * @async
 * @version 1.4.0
 */
export const buyBulkEnable = (ids: number[]): Promise<Packet<boolean>> =>
  putRequest("/v1/FundNoRisk/turnOnBuyBulk", ids);
